Vue.component('v-scroll-alphabet', {
  data: function () {
    return {
      delta: 0,
      position: 0,
      scrollWidth: 0
    }
  },
  mounted: function () {
    this.delta = this.$refs.scrollContainer.offsetWidth
    this.scrollWidth = this.$refs.scrollContainer.scrollWidth
  },
  methods: {
    scrollNext: function () {
      let pos = this.$refs.scrollContainer.scrollLeft
      this.position = pos + this.delta
      this.$refs.scrollContainer.scroll({left: this.position, behavior: 'smooth'})
    },
    scrollPrev: function () {
      let pos = this.$refs.scrollContainer.scrollLeft
      this.position = pos - this.delta
      this.$refs.scrollContainer.scroll({left: this.position, behavior: 'smooth'})
    }
  },
  computed: {
    disabledPrev() {
      return this.position <= 0
    },
    disabledNext() {
      return this.position >= this.scrollWidth
    },
  }
})
